/* eslint-disable class-methods-use-this, import/no-extraneous-dependencies */
import useJwt from '@/auth/jwt/useJwt'

export default class JobVacancyService {
  static list(filters) {
    let params = {}
    if (filters !== undefined) {
      params = Object.fromEntries(Object.entries(filters).filter(filter => filter[1] !== '' && filter[1] !== 'all'))
    }

    params.order_by = params.sortBy + (params.sortDesc ? ' DESC' : '')
    delete params.sortDesc
    delete params.sortBy

    return useJwt.post('/job-vacancies', {}, params)
  }

  static changeStatus(id, status) {
    return useJwt.post(`/job-vacancies/status/${id}`, {}, { status })
  }

  static generateImage(id) {
    return useJwt.post(`/job-vacancies/generate-image/${id}`, {}, { })
  }

  static postOnInstagram(id) {
    return useJwt.post(`/job-vacancies/post-on-instagram/${id}`, {}, { })
  }

  static generateImages(ids) {
    return useJwt.post('/job-vacancies/generate-images', {}, { ids })
  }
}
